<div class="home-container" [ngClass]="{'no-header': !showAppHeader}">
  <div class="content">
    <h1>AISL/xMacroscope Demo</h1>
    <h2>Choose a tab to see individual screens</h2>
  </div>
</div>
